// export const SUPPORTED_LANGUAGES = ["ru", "en", "tr"];
export const SUPPORTED_LANGUAGES = ["ru", "en", "tr"];
export const DEFAULT_LANGUAGE = "ru";
export const NUMBER_QUESTIONS_END = 30;
export const DELAY_SAVING_CLOUD_SECONDS = 1;
export const DELAY_NEXT_QUESTION_SECONDS = 2;
export const ADD_SCORE = 10;
export const LS_NAME = "quizzes0";
export const LB_NAME = "rating0";
